import {
  TokenTextAppearance,
  TextTag,
  Text,
} from '@volkswagen-onehub/components-core';
import React, {useState} from 'react';
import Select, {SingleValue} from 'react-select';
import {OptionType} from '../types/select';

interface SelectCmpInterface {
  options: OptionType[];
  setValue: (v: SingleValue<OptionType>) => void;
  label: string;
  id: string;
  placeholder: string;
}

const SelectCmp: React.FC<SelectCmpInterface> = ({
  options,
  setValue,
  label,
  id,
  placeholder,
}) => {
  const [isOpen, setIsOpen] = useState<boolean | undefined>(undefined);

  const onChangeEvent = (e: SingleValue<OptionType>) => {
    setValue(e);
    setIsOpen(undefined);
  };

  const getBackgroundColor = (isSelected: boolean, isFocused: boolean) => {
    if (isSelected) {
      return '#001e50';
    }

    if (isFocused) {
      return '#00b0f0';
    }

    return undefined;
  };

  return (
    options && (
      <label htmlFor="select">
        <Text tag={TextTag.span} appearance={TokenTextAppearance.copy100}>
          {label}
        </Text>

        <Select
          id={id}
          placeholder={placeholder}
          options={options}
          isSearchable={false}
          menuIsOpen={isOpen}
          onChange={(e) => onChangeEvent(e)}
          onFocus={() => setIsOpen(true)}
          onBlur={() => setIsOpen(false)}
          styles={{
            control: (baseStyles) => ({
              ...baseStyles,
              'padding': '0',
              'border': 'none',
              'borderBottom': '1px solid #eee',
              'borderRadius': 0,
              'margin': 0,

              ':focus-within': {
                outline: '3px solid #4cc7f4',
                outlineRadius: '5px',
                borderRadius: '5px',
              },
            }),
            menuList: (menuListStyle) => ({
              ...menuListStyle,
              padding: 0,
            }),
            valueContainer: (curStyle) => ({
              ...curStyle,
              padding: 0,
            }),
            option: (optionStyle, {isSelected, isFocused}) => ({
              ...optionStyle,
              backgroundColor: getBackgroundColor(isSelected, isFocused),
            }),
          }}
          components={{
            IndicatorSeparator: () => null,
          }}
        />
      </label>
    )
  );
};

export default SelectCmp;
